<template>
  <div class="bg-light">
    <div v-if="isDelegue && !selectedVeterinarian" class="delegate-warning cart-page container">
      <div class="container">
        <div class="warning-message">
          <i class="ti ti-alert-circle"></i>
          <span>Veuillez sélectionner un vétérinaire d'abord</span>
          <router-link to="/dashboard" class="warning-link"> Retour au tableau de bord </router-link>
        </div>
      </div>
    </div>
    <div class="cart-page container" v-else>
      <div class="bg-light">
        <div class="container section-header-breadcrumb">
          <div class="row">
            <div class="content text-left col-sm-12 col-md-12 col-lg-12">
              <h2 class="title-page">Nos Produits</h2>
              <label><span class="pointer-cursor" @click.prevent="GoToDashboard" >Accueil</span>  > <span>Mon panier</span></label>
            </div>
          </div>
        </div>
        <div class="container cart-page">
          <div class="content d-flex gap-4 mb-4 cart-page-inner">
            <div class="col-lg-8 block-products">
              <div class="row step-cart">
                <div class="col-lg-11 col-md-11 col-sm-11">
                  <div class="d-flex gap-4 align-items-center py-4 step-cart-centent">
                    <div class="step-number">
                      <span class="badge badge-blue mx-2">1</span>
                      <span class="step-title">Votre panier</span>
                    </div>
                    <div class="separator"></div>

                    <div class="step-number">
                      <span class="badge mx-2">2</span>
                      <span class="step-title">Livraison</span>
                    </div>
                    <div class="separator"></div>

                    <div class="step-number">
                      <span class="badge mx-2">3</span>
                      <span class="step-title">Paiement</span>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="isDelegue && selectedVeterinarian" class="delegate-header">
                <div class="container">
                  <div class="delegate-info-box">
                    <router-link to="/dashboard" class="delegate-link" @click="clearVeterinarian">
                      <i class="ti ti-arrow-left"></i>
                      Commander pour un autre client
                    </router-link>

                    <div class="delegate-vet-info">
                      <span class="vet-name">{{ selectedVeterinarian.fullName }}</span>
                      <span class="vet-code" v-if="selectedVeterinarian.divalto_id">
                        ({{ selectedVeterinarian.divalto_id }})
                      </span>
                    </div>

                    <router-link :to="delegateProductsLink" class="delegate-link delegate-products-link">
                      Produits délégué
                      <i class="ti ti-arrow-right"></i>
                    </router-link>
                  </div>
                </div>
              </div>

              <!-- loading and message error -->
              <div class="msg-error" v-if="loading">{{ $t("products.loading") }}</div>
              <div
                v-else-if="!loading && cartsupp && (!cartsupp.items || !cartsupp.items.length)"
                class="row justify-content-center cart-products-test"
              >
                <div class="col-lg-12 col-md-12 col-sm-12 text-center" v-if="isClient">
                  <label class="mb-2 msg-error">Votre panier est vide</label><br />
                  <button class="btn text-white btn-check-order mt-2" @click="$router.push('/dashboard/products')">
                    Découvrir nos produits
                  </button>
                </div>
              </div>

              <div class="row mt-4" v-if="!isClient">
                <div class="col-lg-12 col-md-12 col-sm-12 my-2">
                  <label class="title-blue"
                    >Entrez une référence ou un mot-clé pour ajouter<br />
                    rapidement des produits à votre panier.</label
                  >
                </div>
              </div>
              <div class="mb-4">
                <search-product v-if="!isClient" />
              </div>

              <!-- Preorder alert -->
              <div v-if="hasPreorderProduct" class="preorder-alert my-3 mx-4">
                <i class="ti ti-alert-triangle"></i>
                <span>
                  <strong>Important :</strong> vous avez inclus un produit en précommande au sein de votre panier.
                  La totalité des produits ne sera expédiée qu'à partir de la date indiquée.
                  Vous pouvez, si besoin, passer deux commandes distinctes.
                </span>
              </div>

              <div
                v-if="cartsupp && cartsupp.items && cartsupp.items.length > 0"
                class="row justify-content-center cart-products-test"
              >
                <template v-for="(product, index) in cartsupp.items" :key="product.name">
                  <div v-if="showMainLine(product)" class="cart-item" :class="{ compact: cartsupp.items.length > 4 }">
                    <div class="product-image">
                      <img
                        :src="getProductImage(product)"
                        class="img-product"
                        @click="goToProduct(product)"
                        style="cursor: pointer"
                      />
                    </div>
                    <div class="product-info">
                        <span
                        v-if="product.variantDetails?.datePrecommandeSupplyvetEsupplyvet && new Date(product.variantDetails.datePrecommandeSupplyvetEsupplyvet) > new Date()"
                        class="preorder-badge col-6"
                      >
                        Précommande : livraison à partir du
                        {{ new Date(product.variantDetails.datePrecommandeSupplyvetEsupplyvet).toLocaleDateString('fr-FR') }}
                      </span>
                      <label class="title mb-0" @click="goToProduct(product)" style="cursor: pointer">{{
                        product.productName
                      }}</label>
                      <span class="subtitle mb-1" :class="{ 'special-unity': product.variantDetails.unity !== 'u' }">{{ product.variantDetails.name }}</span>
                    
                        <span v-if="product.cart_message && !isClient && !isDelegue" class="cart-message">{{ product.cart_message }}</span>
                      <!-- <span v-if="product.variantDetails.ref" class="sku">Réf: {{ product.variantDetails.ref }}</span> -->

                      <!-- Promotion Display -->
                    </div>
                    <div v-if="loadingId !== product.id" class="input-wrapper-cart">
                      <div class="quantity-controls">
                        <div class="btn-minus" @click.prevent="Decrement(product)">-</div>
                        <input
                          type="text"
                          class="number-input"
                          :value="qtyInput[product.id] ?? getPaidUnits(product)"
                          inputmode="numeric"
                          pattern="[0-9]*"
                          @input="onQtyInput(product, $event)"
                          @blur="onQtyBlur(product)"
                          @keydown="onQtyKeydown($event, product)"
                        />
                        <div class="btn-plus" @click.prevent="Increment(product)">+</div>
                      </div>
                      <div
                        v-if="getTotalUnits(product) > (qtyInput[product.id] ?? getPaidUnits(product))"
                        class="units-info"
                      >
                        soit {{ getTotalUnits(product) }} unités
                      </div>
                    </div>
                    <span v-else class="dot-spinner-container">
                      <span class="dot-spinner">
                        <span class="dot"></span>
                        <span class="dot"></span>
                        <span class="dot"></span>
                        <span class="dot"></span>
                      </span>
                    </span>
                    <div class="block-price">
                      <template v-if="product.unitPrice > product.discountedUnitPrice">
                        <span class="old-price">{{ formatPrice(product.unitPrice / 100) }} € HT</span>
                      </template>

                      <!-- Promotion savings badge -->
                      <!-- <div v-if="hasUgPromotions(product)" class="savings-badge">
                        -{{ getPromotionSavings(product) }}€
                      </div>
                       -->
                      <span class="price" v-if="product.unitPrice === 0">Offert</span>
                      <span class="price" v-else>{{ formatPrice(product.discountedUnitPrice / 100) }} € HT</span>
                    </div>
                    <div class="remove-cart" @click.prevent="DeleteProductFromCart(product)">
                      <img :src="icontrash" class="remove-icon" />
                    </div>
                  </div>

                  <div v-if="hasUgPromotions(product)" class="p-0">
                    <div
                      v-for="(promo, promoIndex) in product.promotionInfo.ugPromotions"
                      :key="'promo-row-' + product.id + '-' + promoIndex"
                      class="cart-item promo-row"  :class="{ compact: cartsupp.items.length > 4 }"
                    >
                      <div class="product-image">
                        <img
                          :src="getProductImage(product)"
                          class="img-product"
                          @click="goToProduct(product)"
                          style="cursor: pointer"
                        />
                      </div>
                      <div class="product-info">
                        <label class="title mb-0" @click="goToProduct(product)" style="cursor: pointer">{{
                          product.productName
                        }}</label>
                        <span class="subtitle mb-1" :class="{ 'special-unity': product.variantDetails.unity !== 'u' }"
                          >{{ product.variantDetails.name }} — {{ formatPromoRowSubtitle(promo) }}</span
                        >
                       
                      </div>

                      <div class="input-wrapper-cart">
                        <div class="quantity-controls disabled">
                          <div class="btn-minus disabled">-</div>
                          <input
                            type="text"
                            class="number-input"
                            :value="getDiscountedUnitsForPromo(promo)"
                            disabled
                            readonly
                          />
                          <div class="btn-plus disabled">+</div>
                        </div>
                      </div>

                      <div class="block-price">
                        <span class="price"
                          >{{ formatPrice(getEffectiveDiscountedUnitPrice(product, promo) / 100) }} € HT</span
                        >
                      </div>

                      <div class="remove-cart" v-if="isDelegue" @click.prevent="deleteUgPromotionFromCart(product)">
                        <img :src="icontrash" class="remove-icon" />
                      </div>
                      <div class="remove-cart" v-else></div>
                    </div>
                  </div>

                  <hr v-if="index < cartsupp.items.length - 1" class="my-2 w-95 mx-4" />
                </template>
              </div>
              <div v-if="cartsupp && cartsupp.items && cartsupp.items.length > 0" class="row">
                <div
                  class="col-lg-12 col-md-12 col-sm-12 text-center my-4 d-flex align-items-center justify-content-center"
                >
                <a href="#" class="clear-cart-link" @click.prevent="confirmClearCart">
                  <img :src="icontrash" style="height: 30px; vertical-align: middle;" />
                  Vider le panier
                </a>
                </div>
              </div>
            </div>
            <div class="col-lg-4 py-3 block-recap">
              <label class="title-recap">Récapitulatif de la commande</label>
               <!-- Warehouse closure notice -->
                <div v-if="warehouseNotice && warehouseNotice.enabled && warehouseNotice.content" class="alert alert-info my-3 d-flex align-items-start gap-2">
                  <i class="ti ti-info-circle mt-1"></i>
                  <div v-html="warehouseNotice.content" class="text-start"></div>
                </div>
              <div class="my-4 coupon-block" v-if="user.role == 'client'">
                <label class="recap-text">Utiliser le code promo</label>
                <div class="d-flex">
                  <input
                    type="text"
                    class="form-control me-2"
                    placeholder="Entrez votre code promo"
                    v-model="promoCode"
                  />
                  <button
                    class="btn btn-outline-orange d-flex align-items-center"
                    :class="{ disabled: !promoCode?.trim() || loadingPromo }"
                    @click="applyPromoCode"
                    :disabled="!promoCode?.trim() || loadingPromo"
                  >
                    Appliquer <span v-if="loadingPromo" class="spinner-circle-small white ms-2"></span>
                  </button>
                </div>
              </div>

              <div class="my-4 summary-row">
                <label class="col-lg-9 recap-text">Prix des produits</label>
                <span class="col-lg-3 recap-text px-0">{{ TotalCart }} € HT</span>
              </div>
              <div class="my-4 summary-row" v-if="user.role == 'client' && showRemiseLine && remise && couponCode">
                <label class="col-lg-9 recap-text">Remise</label>
                <span class="col-lg-3 recap-text px-0">{{ remise }} € </span>
                <br />
                <span class="text-slogan" v-if="!loadingDeletePromo"
                  >{{ couponCode }} <img :src="icontrash" class="remove-icon-promo" @click="DeletePromoCode"
                /></span>
                <span v-else class="spinner-circle-small orange ms-2"></span>
              </div>

              <div class="my-4 summary-row" v-if="user.role !== 'client' && showRemiseLine && remise">
                <p class="col-lg-9">
                  <label class="recap-text">Remise</label>
                  <br />
                  <span class="text-slogan">inclus dans le prix des produits</span>
                </p>
                <span class="col-lg-3 recap-text px-0">{{ remise }} € </span>
              </div>

              <div class="my-4 summary-row" v-if="tvaTieCode === '0'">
                <label class="col-lg-9 recap-text">TVA</label>
                <span class="col-lg-3 recap-text px-0">{{ Tva }} €</span>
              </div>

              <div class="my-4 summary-row">
                <p class="col-lg-10">
                  <label class="recap-text">Livraison</label>
                  <br />
                  <span class="text-slogan">Frais calculés à l'étape suivante</span>
                </p>
              </div>
              <hr class="divider" />
              <div class="my-4 summary-row" v-if="tvaTieCode === '0'">
                <label class="col-lg-9 col-md-9 col-sm-9 recap-text">Total TVA inclus</label>
                <span class="col-lg-3 col-md-3 col-sm-3 recap-text-blue px-0">{{ TotalCartTTC }} € TTC</span>
              </div>
              <div class="my-4 summary-row" v-else>
                <label class="col-lg-9 col-md-9 col-sm-9 recap-text">Total</label>
                <span class="col-lg-3 col-md-3 col-sm-3 recap-text-blue px-0">{{ TotalCartTTC }} € HT</span>
              </div>
              <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 text-center">
                  <button class="btn text-white btn-check-order mt-2" @click="GoLivraison()" :disabled="!isCartValid">
                    Valider mon panier
                  </button>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 text-center mt-2">
                  <span class="text-slogan mt-3">Paiement 100% sécurisé avec technologies ssl et 3D Secure.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modale de confirmation -->
    <div v-if="showClearConfirm" class="modal-overlay" @click="showClearConfirm = false">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h3>Confirmation</h3>
          <button class="modal-close" @click="showClearConfirm = false">×</button>
        </div>
        <div class="modal-body">
          <p>Vous êtes sur le point de vider votre panier : êtes-vous sûr(e) ?</p>
        </div>
        <div class="modal-footer">
          <button class="btn btn-outline-secondary" @click="showClearConfirm = false">Non</button>
          <button class="btn btn-danger" @click="confirmClear" :disabled="loadingClear">
            Oui
            <span v-if="loadingClear" class="spinner-circle-small-modal white ms-2"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import icontrash from "@/assets/trash.svg";
  import iconplus from "@/assets/plus.svg";
  import ProductDefault from "@/assets/images/product_default.png";
  import { useProductsStore } from "@/stores/productsStore";
  import { useCartStore } from "@/stores/cartStore";
  import { useRegisterStore } from "@/stores/register";
  import { useToast } from "vue-toastification";
  import $ from "jquery";
  import SearchProduct from "@/components/SearchProduct.vue";
  import { removePromoCode, updateOrder, deleteUgPromotion, getWarehouseNoticeConfiguration } from "@/api/orders";
  import { useCheckoutStore } from "@/stores/useCheckoutStore";
  import { useDelegueStore } from "@/stores/delegueStore";
  import { useGammesStore } from "@/stores/gammesStore";
  export default {
    watch: {},
    components: { SearchProduct },
    name: "CartPage",
    data() {
      return {
        cart: {
          items: [],
        },
        size: "50px",
        color: "#3498db",
        icontrash,
        iconplus,
        ProductDefault,
        searchQuery: "",
        showResults: false,
        cartStore: null,
        productsStore: null,
        products_variants: [],
        qt: [],
        qtyInput: {},
        registerStore: null,
        promoCode: "",
        loadingPromo: false,
        loadingDeletePromo: false,
        showClearConfirm: false,
        warehouseNotice: null,
      };
    },
    computed: {
      user() {
        return this.registerStore.user;
      },
      // spinnerStyle() {
      //   return {
      //     width: this.size,
      //     height: this.size,
      //     borderColor: `${this.color} transparent transparent transparent`,
      //   };
      // },
      filteredProducts() {
        this.products_variants.map(prod => {
          this.qt[prod.id] = 1;
          return prod;
        });
        return this.products_variants.filter(
          product =>
            product.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
            product.inventoryName.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
            (product.ref && product.ref.toLowerCase().includes(this.searchQuery.toLowerCase()))
        );
      },
      TotalCart() {
        var total = 0;
        var cartStore = useCartStore();
        if (cartStore.Cart && cartStore.Cart.items && cartStore.Cart.items.length > 0)
          total = cartStore.Cart.itemsSubtotal / 100;
        return this.formatPrice(total);
      },
      Tva() {
        var total = 0;
        var cartStore = useCartStore();
        if (cartStore.Cart && cartStore.Cart.items && cartStore.Cart.items.length > 0)
          total = (cartStore.Cart.taxTotal - (cartStore.Cart.shippingTotal - cartStore.Cart.shippingTaxTotal)) / 100;
        return this.formatPrice(total);
      },

      tvaTieCode() {
        var cartStore = useCartStore();
        return cartStore.Cart.tvaTieCode;
      },
      TotalCartTTC() {
        var total = 0;
        var cartStore = useCartStore();
        if (cartStore.Cart && cartStore.Cart.items && cartStore.Cart.items.length > 0)
          total = cartStore.Cart.itemsTotal / 100;
        return this.formatPrice(total);
      },
      remise() {
        var total = 0;
        var cartStore = useCartStore();
        total = cartStore.Cart.orderPromotionTotal / 100;
        return total ? this.formatPrice(total) : 0;
      },
      couponCode() {
        const cartStore = useCartStore();
        return cartStore.Cart?.coupon_code || "";
      },
      cartsupp() {
        var cartStore = useCartStore();
        return cartStore.Cart;
      },
      loading() {
        return this.cartStore.loading;
      },
      loadingId() {
        return this.cartStore.loadingId;
      },
      loadingClear() {
        return this.cartStore.loadingClear;
      },
      isClient() {
        return this.registerStore.user?.role === "client";
      },

      isCartValid() {
        // Check if the cart exists and has at least one item
        return this.cartsupp && this.cartsupp.items && this.cartsupp.items.length > 0;
      },

      hasPreorderProduct() {
        if (!this.cartsupp?.items?.length) return false;
        const today = new Date();
        return this.cartsupp.items.some(item => {
          const date = item.variantDetails?.datePrecommandeSupplyvetEsupplyvet;
          return date && new Date(date) > today;
        });
      },

      isDelegue() {
        return this.registerStore.user?.role === "delegues";
      },
      selectedVeterinarian() {
        const delegueStore = useDelegueStore();
        return delegueStore.getSelectedVeterinarian;
      },
      delegateProductsLink() {
        const gammesStore = useGammesStore();
        const delegateGamme = gammesStore.gammes.find(
          gamme => gamme.code === "produits-delegue" || gamme.name === "Produits délégués"
        );

        if (delegateGamme) {
          return `/dashboard/taxon/${delegateGamme.id}-${delegateGamme.slug}`;
        }

        return "/dashboard/taxon/121-produits-delegue";
      },

      showRemiseLine() {
        const subtotal = this.cartsupp?.itemsSubtotal || 0;
        const remiseValue = Math.abs(this.cartsupp?.orderPromotionTotal || 0);
        return subtotal > 0 && remiseValue > 0 && remiseValue < subtotal;
      },
    },
    mounted() {
      document.addEventListener("click", this.hideWithDelay);

      this.productsStore = useProductsStore();
      this.productsStore.fetchAllProducts();
      this.ListVariants();
    },
    async created() {
      this.cartStore = useCartStore();
      this.registerStore = useRegisterStore();
      await this.cartStore.fetchCart();
      this.fetchWarehouseNotice();
    },
    methods: {
      async fetchWarehouseNotice() {
        try {
          this.warehouseNotice = await getWarehouseNoticeConfiguration();
        } catch (error) {
          console.error("Failed to fetch warehouse notice configuration:", error);
        }
      },
      ListVariants() {
        this.productsStore.allProducts.map(prod => {
          if (prod.variantsDetails) {
            prod.variantsDetails.map(variant => {
              variant.gamme = prod.gamme;
              variant.image = prod.imagesDetails ? prod.imagesDetails[0].path : "";
              const isPrecommande = 
                (variant.datePrecommandeSupplyvetEsupplyvet && new Date(variant.datePrecommandeSupplyvetEsupplyvet) > new Date()) ||
                (prod.datePrecommandeSupplyvetEsupplyvet && new Date(prod.datePrecommandeSupplyvetEsupplyvet) > new Date());
              if (variant.inStock || isPrecommande) this.products_variants.push(variant);
            });
          }
        });
      },
      async Increment(product) {
        const cartStore = useCartStore();
        if (this.hasUgPromotions(product)) {
          const currentPaid = this.getPaidUnits(product);
          const discounted = this.getTotalDiscountedUnits(product);
          const targetTotal = currentPaid + 1 + discounted;
          const delta = targetTotal - product.quantity;
          if (delta !== 0) {
            await cartStore.smartIncrementDecrement(product.productSlug, product, delta);
          }
        } else {
          await cartStore.smartIncrementDecrement(product.productSlug, product, 1);
        }
      },
      async Decrement(product) {
        const cartStore = useCartStore();
        if (this.hasUgPromotions(product)) {
          const currentPaid = this.getPaidUnits(product);
          if (currentPaid > 1) {
            const discounted = this.getTotalDiscountedUnits(product);
            const targetTotal = currentPaid - 1 + discounted;
            const delta = targetTotal - product.quantity;
            if (delta !== 0) {
              await cartStore.smartIncrementDecrement(product.productSlug, product, delta);
            }
          } else {
            await cartStore.smartIncrementDecrement(product.productSlug, product, -product.quantity);
          }
        } else {
          if (product.quantity > 1) {
            await cartStore.smartIncrementDecrement(product.productSlug, product, -1);
          } else {
            await cartStore.smartIncrementDecrement(product.productSlug, product, -product.quantity);
          }
        }
      },

      onQtyInput(product, event) {
        const raw = event.target.value ?? "";
        const digits = String(raw).replace(/\D/g, "");
        this.qtyInput[product.id] = digits;
      },

      async onQtyBlur(product) {
        const buffered = this.qtyInput[product.id];
        if (buffered === undefined || buffered === "") {
          delete this.qtyInput[product.id];
          return;
        }
        const newQty = parseInt(buffered, 10);
        if (!Number.isFinite(newQty)) {
          delete this.qtyInput[product.id];
          return;
        }
        try {
          if (this.hasUgPromotions(product)) {
            const desiredPaid = newQty;
            if (desiredPaid <= 0) {
              await this.cartStore.smartIncrementDecrement(product.productSlug, product, -product.quantity);
            } else {
              const discounted = this.getTotalDiscountedUnits(product);
              const targetTotal = desiredPaid + discounted;
              const delta = targetTotal - product.quantity;
              if (delta !== 0) {
                await this.cartStore.smartIncrementDecrement(product.productSlug, product, delta);
              }
            }
          } else {
            if (newQty <= 0) {
              await this.cartStore.smartIncrementDecrement(product.productSlug, product, -product.quantity);
            } else {
              const delta = newQty - product.quantity;
              if (delta !== 0) {
                await this.cartStore.smartIncrementDecrement(product.productSlug, product, delta);
              }
            }
          }
        } finally {
          delete this.qtyInput[product.id];
        }
      },

      onQtyKeydown(event, product) {
        const e = event;
        const allowedKeys = ["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight", "Home", "End"];
        if (e.key === "Enter") {
          e.preventDefault();
          this.onQtyBlur(product);
          return;
        }
        if (allowedKeys.includes(e.key)) return;
        if ((e.ctrlKey || e.metaKey) && ["a", "c", "v", "x", "A", "C", "V", "X"].includes(e.key)) return;
        if (/^\d$/.test(e.key)) return;
        e.preventDefault();
      },
      async DeleteProductFromCart(product) {
        await this.cartStore.removeFromCart(product.id);
        await this.cartStore.fetchCart();
      },
      // ClearCart() {
      //   this.cartStore.clearCart();
      //   const toast = useToast();
      //   toast.success("Panier vidé avec succès");
      // },
      // ShowProducts() {
      //   this.products_variants = [];
      //   this.productsStore = useProductsStore();
      //   this.productsStore.fetchProducts();
      //   this.ListVariants();
      //   if (this.productsStore.allProducts.length > 0) {
      //     this.showResults = true;
      //     $(".search-input").css({
      //       "border-radius": "25px 25px 0 0",
      //       "border-bottom": "none",
      //     });
      //   }
      // },
      hideWithDelay(event) {
        if (this.$refs.SearchInput && !this.$refs.SearchInput.contains(event.target)) {
          setTimeout(() => {
            this.showResults = false;
            $(".search-input").css({
              "border-radius": "25px",
              "border-bottom": "1px solid #AEB1BA",
            });
          }, 200);
        }
      },
      // IncrementQtWithSearch(product) {
      //   this.qt[product.id] += 1;
      // },
      // DecrementQtWithSearch(product) {
      //   if (this.qt[product.id] > 1) this.qt[product.id] -= 1;
      // },
      // async AddProductToCart(product) {
      //   var qt_prod = this.qt[product.id];
      //   await this.cartStore.addToCart(product.code, qt_prod);
      //   this.showResults = false;
      //   this.searchQuery = "";
      //   $(".search-input").css({
      //     "border-radius": "25px",
      //     "border-bottom": "1px solid #AEB1BA",
      //   });
      //   this.qt[product.id] = 1;
      //   const toast = useToast();
      //   toast.success("Produit ajouté au panier avec succès");
      // },
      formatPrice(value) {
        if (value == null || isNaN(value)) return '0,00';
        const num = Number(value);
        return num.toFixed(2).replace('.', ',');
      },
      GoLivraison() {
        this.$router.push({ name: "livraison" });
      },
      goToProduct(product) {
        const slug = product.productSlug;
        console.log(slug);
        if (slug) {
          this.$router.push({ name: "ProductDetail", params: { slug } });
        }
      },


       getProductImage(product) {
        const variant = product.variantDetails;
        
        if (variant?.imagesDetails?.length > 0) {
          return variant.imagesDetails[0].path;
        }
        
        if (variant?.imagesProduct?.length > 0) {
          
          const variantImages = variant.imagesProduct.filter(img => 
            img.productVariants && 
            img.productVariants.includes(`/api/v2/shop/product-variants/${variant.code}`)
          );
          
          if (variantImages.length > 0) {
            return variantImages[0].path;
          }
          
         
          return variant.imagesProduct[0].path;
        }
        
        return ProductDefault;
      },
      async applyPromoCode() {
        this.loadingPromo = true;
        const checkoutStore = useCheckoutStore();
        const cartStore = useCartStore();
        const tokenValue = this.cartsupp.tokenValue;
        const payload = {
          couponCode: this.promoCode?.trim(),
        };
        try {

          const delegueStore = useDelegueStore();
          const registerStore = useRegisterStore();
          const vetId = delegueStore.getSelectedVeterinarian?.id;
          const userRole = registerStore.user?.role || "";
          const response = await updateOrder(tokenValue, payload,userRole==='delegues', vetId);
          checkoutStore.setOrder(response.data);
          cartStore.cart = response.data;
          const toast = useToast();
          toast.success("Code promo appliqué avec succès");
        } catch (error) {
          console.error("Error applying promo code:", error);
          const toast = useToast();
          toast.error("Erreur lors de l'application du code promo");
        } finally {
          this.promoCode = "";
          this.loadingPromo = false;
        }
      },

      async DeletePromoCode() {
        this.loadingDeletePromo = true;
        const checkoutStore = useCheckoutStore();
        const tokenValue = this.cartsupp.tokenValue;
        try {
          await removePromoCode(tokenValue);
          await this.cartStore.fetchCart();
          checkoutStore.setOrder(this.cartsupp);
          const toast = useToast();
          toast.success("Code promo supprimé avec succès");
        } catch (error) {
          console.error("Error removing promo code:", error);
          const toast = useToast();
          toast.error("Erreur lors de la suppression du code promo");
        } finally {
          this.loadingDeletePromo = false;
        }
      },

      getTotalUnits(product) {
        const variant = product.variantDetails;
        const buffered = this.qtyInput[product.id];
        const quantity =
          buffered !== undefined && buffered !== "" ? parseInt(buffered, 10) || 0 : this.getPaidUnits(product);

        if (!variant || !variant.unity) {
          return quantity;
        }

        if (variant.unity === "u") {
          return quantity;
        }

        const match = variant.unity.match(/^(\d+)u$/);
        if (match) {
          const unitsPerPack = parseInt(match[1], 10);
          return quantity * unitsPerPack;
        }
        return quantity;
      },

      hasUgPromotions(product) {
        return product.promotionInfo?.ugPromotions && product.promotionInfo.ugPromotions.length > 0;
      },
      //
      // formatPromotionText(promo) {
      //   if (promo.isFullDiscount) {
      //     return `${promo.discountedUnits} produit${promo.discountedUnits > 1 ? "s" : ""} offert${promo.discountedUnits > 1 ? "s" : ""}`;
      //   } else if (promo.discountPercent > 0) {
      //     return `${promo.discountPercent}% sur ${promo.discountedUnits} unité${promo.discountedUnits > 1 ? "s" : ""}`;
      //   } else {
      //     return promo.name;
      //   }
      // },

      getPaidUnits(product) {
        return product?.promotionInfo?.totalPaidUnits ?? product.quantity ?? 0;
      },

      showMainLine(product) {
        return !this.hasUgPromotions(product) || this.getPaidUnits(product) > 0;
      },

      getTotalDiscountedUnits(product) {
        if (product?.promotionInfo?.totalDiscountedUnits != null) {
          return product.promotionInfo.totalDiscountedUnits;
        }
        if (product?.promotionInfo?.ugPromotions?.length) {
          return product.promotionInfo.ugPromotions.reduce((sum, p) => sum + (p.discountedUnits || 0), 0);
        }
        return 0;
      },

      isPromoFullDiscount(promo) {
        return promo?.isFullDiscount || promo?.discountPercent === 100;
      },

      getDiscountedUnitsForPromo(promo) {
        return promo?.discountedUnits || 0;
      },

      getEffectiveDiscountedUnitPrice(product, promo) {
        const base = product.unitPrice ?? product.discountedUnitPrice ?? 0;
        const perUnit = promo?.discountPerUnit ?? 0;
        if (this.isPromoFullDiscount(promo)) return 0;
        return Math.max(base - perUnit, 0);
      },

      formatPromoRowSubtitle(promo) {
        return this.isPromoFullDiscount(promo) ? "Unité offerte" : `Unité à prix promo (-${promo.discountPercent}%)`;
      },

      getPromotionSavings(product) {
        if (!this.hasUgPromotions(product)) return 0;

        return (
          product.promotionInfo.ugPromotions.reduce((total, promo) => {
            return total + promo.totalDiscount;
          }, 0) / 100
        );
      },

      async clearVeterinarian() {
        await this.cartStore.clearCart();
        const delegueStore = useDelegueStore();
        delegueStore.clearSelectedVeterinarian();
        this.cartStore.reintializeCart();
      },
      GoToDashboard() {
        this.$router.push({ name: "dashboard-home" });
      },
      confirmClearCart() {
        this.showClearConfirm = true;
      },

      async confirmClear() {
        await this.cartStore.clearCart();
        this.showClearConfirm = false;
        const toast = useToast();
        toast.success("Panier vidé avec succès");
      },

      /**
       * Supprime une promotion UG (unité gratuite) spécifique
       * Réservé uniquement aux délégués
       */
      async deleteUgPromotionFromCart(product) {
        if (!this.isDelegue) {
          console.warn("Suppression des promotions UG réservée aux délégués uniquement");
          return;
        }
        try {
          this.loadingId = product.id;
          const orderToken = this.cartsupp.tokenValue;
          const variantId = product.variantDetails.id;
          await deleteUgPromotion(orderToken, variantId);
          await this.cartStore.fetchCart();
          const toast = useToast();
          toast.success("Promotion supprimée avec succès");
        } catch (error) {
          console.error("Erreur lors de la suppression de la promotion UG:", error);
          const toast = useToast();
          toast.error("Erreur lors de la suppression de la promotion");
        } finally {
          this.loadingId = null;
        }
      },
    },
  };
</script>

<style scoped>
  .cart-page {
    padding: 15px;
    text-align: center;
    min-height: 500px;
  }

  .section-header-breadcrumb {
    text-align: left;
    font-style: normal;
    padding: 0 15px;
  }

  .section-header-breadcrumb .title-page {
    font-size: 30px;
    font-weight: bold;
    color: #1e347d;
  }

  .section-header-breadcrumb label {
    font-size: 15px;
    font-weight: normal;
  }

  .section-header-breadcrumb label span {
    color: #1e347d;
  }

  .step-cart {
    justify-content: center;
    margin-bottom: 3rem;
  }

  .title-blue {
    color: #1e347d;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  }

  .msg-error {
    color: #1e347d;
    font-size: 15px;
    text-align: center;
  }

  .step-cart-centent {
    justify-content: center;
    border: 1px solid #aeb1ba;
    border-radius: 10px;
  }

  .badge-blue {
    background-color: #1e347d !important;
    color: white !important;
    border-radius: 50%;
    font-size: 1.5rem;
  }

  .badge {
    background-color: #eee;
    color: #ec621a;
    border-radius: 50%;
    font-size: 1.5rem;
  }

  .step-cart .step-title {
    color: #000;
    font-weight: bold;
    font-size: 18px;
    opacity: 0.7;
  }

  .block-products {
    background: white;
    padding-top: 2rem;
    border: 1px solid #ddd;
    border-radius: 10px;
    box-shadow: 0px 10px 6px rgba(0, 0, 0, 0.1);
  }

  /* NOUVEAU CSS POUR L'ALIGNEMENT PARFAIT */
  .cart-item {
    display: grid;
    grid-template-columns: 120px 1fr 130px 120px 50px;
    align-items: center;
    gap: 2px;
    padding: 15px 24px;
    margin-bottom: 10px;
  }

  .cart-item .product-image {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 110px;
  }

  .cart-item .product-image img.img-product {
    max-height: 110px;
    max-width: 100px;
    object-fit: contain;
  }

  .cart-item .product-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;
    width: 100% !important;
  }

  .cart-item .product-info .title {
    font-size: 14px;
    font-weight: bold;
    color: #1e347d;
    margin-bottom: 5px;
    cursor: pointer;
  }

  .cart-item .product-info .subtitle {
    font-weight: 700;
    font-size: 12px;
    margin-bottom: 3px;
  }

  .cart-item .product-info .sku {
    font-size: 12px;
    color: #777;
  }

  /* Input wrapper parfaitement aligné */
  .input-wrapper-cart {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .quantity-controls {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .units-info {
    font-size: 14px;
    color: #777;
    margin-top: 3px;
    font-style: italic;
  }

  .btn-minus,
  .btn-plus {
    width: 35px;
    height: 35px;
    color: #fff;
    font-size: 20px;
    text-align: center;
    cursor: pointer;
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.3s;
  }

  .btn-minus {
    background-color: #ec621a;
    opacity: 0.5;
    border-radius: 30px 0 0 30px;
  }

  .btn-plus {
    background-color: #ec621a;
    border-radius: 0 30px 30px 0;
  }

  .number-input {
    width: 50px;
    border: 1px solid rgba(236, 98, 26, 0.4);
    text-align: center;
    font-size: 16px;
    outline: none;
    color: #ec621a;
    height: 35px;
    border-radius: 0;
  }

  /* Prix aligné au centre */
  .block-price {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .price {
    font-weight: bold;
    font-size: 18px;
    color: #1e347d;
  }

  .old-price {
    font-weight: bold;
    font-size: 14px;
    color: gray;
    text-decoration: line-through;
    margin-bottom: 2px;
  }

  /* Bouton supprimer aligné */
  .remove-cart {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .remove-icon {
    height: 32px;
    transition: opacity 0.3s;
  }
  .remove-icon-promo {
    height: 26px;
    transition: opacity 0.3s;
    cursor: pointer;
  }

  .remove-icon-promo:hover {
    opacity: 0.7;
  }

  .remove-icon:hover {
    opacity: 0.7;
  }
  .btn-outline-orange {
    &.disabled {
      background-color: var(--orange) !important;
      color: var(--white) !important;
    }
  }
  /* Spinner aligné avec le reste */
  .dot-spinner-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 35px;
  }

  /* Mode compact pour plus de 4 produits */
  .cart-item.compact {
    grid-template-columns: 80px 1fr 110px 100px 40px;
    gap: 30px;
    padding: 10px 24px;
  }

  .cart-item.compact .product-image {
    height: 80px;
  }

  .cart-item.compact .product-image img.img-product {
    max-height: 70px;
    max-width: 70px;
  }

  .cart-item.compact .product-info .title {
    font-size: 12px;
  }

  .cart-item.compact .product-info .subtitle {
    font-size: 11px;
  }

  .cart-item.compact .product-info .sku {
    font-size: 10px;
  }

  .cart-item.compact .btn-minus,
  .cart-item.compact .btn-plus {
    width: 30px;
    height: 30px;
    font-size: 18px;
  }

  .cart-item.compact .number-input {
    width: 40px;
    height: 30px;
    font-size: 14px;
  }

  .cart-item.compact .price {
    font-size: 15px !important;
  }

  .cart-item.compact .old-price {
    font-size: 12px;
  }

  .cart-item.compact .remove-icon {
    height: 28px;
  }

  .cart-item.compact .dot-spinner-container {
    height: 30px;
  }

  /* Reste des styles inchangés */
  .block-recap {
    background: white;
    text-align: left;
    padding: 30px;
    height: max-content;
    border: 1px solid #ddd;
    border-radius: 10px;
    box-shadow: 0px 10px 6px rgba(0, 0, 0, 0.1);
  }

  .block-recap .title-recap {
    color: #1e347d;
    font-size: 20px;
    font-weight: bold;
  }

  .block-recap .recap-text {
    font-size: 15px;
    font-weight: bold;
  }

  .block-recap .recap-text-blue {
    font-size: 16px;
    color: #1e347d;
    font-weight: bold;
    text-wrap-mode: nowrap;
  }

  .block-recap .text-slogan {
    font-size: 12px;
    color: #1e347d;
    font-style: italic;
  }

  .block-recap .divider {
    width: 90%;
    position: relative;
    left: 5%;
  }

  .btn-check-order,
  .btn-clear-cart {
    background-color: #ec621a !important;
    border-radius: 50px;
    font-size: 16px !important;
    font-weight: bold;
    text-align: center;
  }

  /* Spinner styles */
  .dot-spinner {
    position: relative;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: transparent;
    color: #ec621a;
    animation: dotFlashing 1s infinite linear alternate;
    animation-delay: 0.5s;
  }

  .dot-spinner::before,
  .dot-spinner::after {
    content: "";
    display: inline-block;
    position: absolute;
    top: 0;
  }

  .dot-spinner::before {
    left: -15px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #ec621a;
    color: #ec621a;
    animation: dotFlashing 1s infinite alternate;
    animation-delay: 0s;
  }

  .dot-spinner::after {
    left: 15px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #ec621a;
    color: #ec621a;
    animation: dotFlashing 1s infinite alternate;
    animation-delay: 1s;
  }

  @keyframes dotFlashing {
    0% {
      background-color: #ec621a;
    }
    50%,
    100% {
      background-color: rgba(236, 98, 26, 0.2);
    }
  }

  /* Responsive Design */

  /* Large Desktop (1200px and up) */
  @media (min-width: 1200px) {
    .cart-item {
      grid-template-columns: 140px 1fr 150px 130px 60px;
      gap: 2px;
      padding: 20px 30px;
    }

    .cart-item .product-image {
      height: 120px;
    }

    .cart-item .product-image img.img-product {
      max-height: 120px;
      max-width: 110px;
    }

    .cart-item .product-info .title {
      font-size: 16px;
    }

    .cart-item .product-info .subtitle {
      font-size: 14px;
    }

    .price {
      font-size: 20px;
    }

    .old-price {
      font-size: 16px;
    }
  }

  /* Desktop (992px to 1199px) */
  @media (min-width: 992px) and (max-width: 1199px) {
    .cart-item {
      grid-template-columns: 120px 1fr 130px 120px 50px;
      gap: 15px;
      padding: 15px 24px;
    }

    .cart-item .product-image {
      height: 110px;
    }

    .cart-item .product-image img.img-product {
      max-height: 110px;
      max-width: 100px;
    }
  }

  /* Tablet (768px to 991px) */
  @media (min-width: 768px) and (max-width: 991px) {
    .cart-page {
      padding: 40px 15px;
    }
    .cart-page-inner {
      flex-direction: column !important;
      gap: 20px !important;
    }
    .step-cart-centent {
      flex-direction: row !important;
    }
    .col-lg-8 {
      width: 100% !important;
    }

    .col-lg-4 {
      width: 100% !important;
    }

    .cart-item {
      grid-template-columns: 100px 1fr 120px 100px 45px;
      gap: 12px;
      padding: 12px 20px;
    }

    .cart-item .product-image {
      height: 90px;
    }

    .cart-item .product-image img.img-product {
      max-height: 85px;
      max-width: 80px;
    }

    .cart-item .product-info .title {
      font-size: 13px;
    }

    .cart-item .product-info .subtitle {
      font-size: 11px;
    }

    .btn-minus,
    .btn-plus {
      width: 32px;
      height: 32px;
      font-size: 18px;
    }

    .number-input {
      width: 45px;
      height: 32px;
      font-size: 15px;
    }

    .price {
      font-size: 16px;
    }

    .old-price {
      font-size: 13px;
    }

    .remove-icon {
      height: 28px;
    }

    /* Mode compact pour tablet */
    .cart-item.compact {
      grid-template-columns: 70px 1fr 100px 80px 35px;
      gap: 8px;
      padding: 8px 15px;
    }

    .cart-item.compact .product-image {
      height: 70px;
    }

    .cart-item.compact .product-image img.img-product {
      max-height: 65px;
      max-width: 60px;
    }
  }

  /* Mobile Large (576px to 767px) */
  @media (min-width: 576px) and (max-width: 767px) {
    .cart-page {
      padding: 8px;
    }

    .cart-page-inner {
      flex-direction: column !important;
      gap: 15px !important;
    }

    .col-lg-8,
    .col-lg-4 {
      width: 100% !important;
    }

    .block-products {
      padding-top: 1rem;
    }

    .step-cart-centent {
      flex-direction: row !important;
      gap: 10px !important;
    }

    .step-cart .step-title {
      font-size: 14px;
    }

    .badge,
    .badge-blue {
      font-size: 1.2rem;
    }
    .separator {
      display: block !important;
    }
    /* Cart items en mode colonne pour mobile */
    .cart-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      padding: 15px;
      border-radius: 10px;
      margin-bottom: 15px;
      gap: 10px;
    }

    .cart-item .product-image {
      height: 80px;
      width: 80px;
    }

    .cart-item .product-image img.img-product {
      max-height: 75px;
      max-width: 75px;
    }

    .cart-item .product-info {
      text-align: center;
    }

    .cart-item .product-info .title {
      font-size: 14px;
      margin-bottom: 8px;
    }

    .cart-item .input-wrapper-cart {
      width: 100%;
      justify-content: center;
    }

    .cart-item .block-price {
      width: 100%;
    }

    .cart-item .remove-cart {
      width: 100%;
    }

    /* Désactive le mode compact sur mobile */
    .cart-item.compact {
      display: flex;
      flex-direction: column;
    }

    .block-recap {
      padding: 20px;
    }

    .block-recap .title-recap {
      font-size: 18px;
    }

    .block-recap .recap-text {
      font-size: 16px;
    }
  }

  /* Mobile Small (up to 575px) */
  @media (max-width: 575px) {
    .cart-page {
      padding: 5px;
    }

    .section-header-breadcrumb {
      padding: 0 10px;
    }

    .section-header-breadcrumb .title-page {
      font-size: 20px;
      margin-top: 9px;
    }

    .cart-page-inner {
      flex-direction: column !important;
      gap: 10px !important;
    }

    .col-lg-8,
    .col-lg-4 {
      width: 100% !important;
    }

    .block-products {
      padding: 10px;
    }

    /* Steps en mode très compact */
    .step-cart-centent {
      flex-direction: row !important;
      gap: 8px;
      padding: 15px;
    }

    .step-number {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .badge,
    .badge-blue {
      font-size: 1rem;
      display: none !important;
    }
    .step-cart .step-title {
      font-size: 9px !important;
      text-wrap-mode: nowrap;
    }

    .separator {
      display: block !important;
      width: 39px !important;
    }
    /* Cart items en mode 2 lignes pour mobile */
    .cart-item {
      display: grid;
      grid-template-columns: auto 1fr;
      grid-template-rows: auto auto;
      gap: 10px;
      padding: 12px;
      border: 1px solid #eee;
      border-radius: 8px;
      margin-bottom: 12px;
    }

    /* Ligne 1: Image + Nom du produit */
    .cart-item .product-image {
      grid-column: 1;
      grid-row: 1;
      height: 60px;
      width: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .cart-item .product-image img.img-product {
      max-height: 55px;
      max-width: 55px;
      object-fit: contain;
    }

    .cart-item .product-info {
      grid-column: 2;
      grid-row: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: left;
    }

    .cart-item .product-info .title {
      font-size: 13px;
      margin-bottom: 5px;
    }

    .cart-item .product-info .subtitle {
      font-size: 11px;
    }

    .cart-item .product-info .sku {
      font-size: 10px;
    }

    /* Ligne 2: Sélecteur quantité + Prix + Poubelle */
    .cart-item .input-wrapper-cart {
      grid-column: 1;
      grid-row: 2;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    .btn-minus,
    .btn-plus {
      width: 28px;
      height: 28px;
      font-size: 16px;
    }

    .number-input {
      width: 40px;
      height: 24px;
      font-size: 14px;
    }

    .cart-item .block-price {
      grid-column: 2;
      grid-row: 2;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 10px;
    }

    .price {
      font-size: 14px;
    }

    .old-price {
      font-size: 12px;
    }

    .cart-item .remove-cart {
      grid-column: 2;
      grid-row: 2;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 15px;
      margin: -15px;
      z-index: 10;
    }

    .remove-icon {
      height: 24px;
    }

    /* Récapitulatif responsive */
    .block-recap {
      padding: 15px;
    }

    .block-recap .title-recap {
      font-size: 16px;
    }

    .block-recap .recap-text {
      font-size: 14px;
    }

    .block-recap .recap-text-blue {
      font-size: 16px;
    }

    .btn-check-order,
    .btn-clear-cart {
      font-size: 14px !important;
      padding: 6px 13px;
    }

    /* FIX: Ensure compact mode doesn't break mobile layout */
    .cart-item.compact {
      display: grid;
      grid-template-columns: auto 1fr;
      grid-template-rows: auto auto;
      gap: 10px;
      padding: 12px;
    }

    .cart-item.compact .product-image {
      height: 60px;
      width: 60px;
    }

    .cart-item.compact .product-image img.img-product {
      max-height: 55px;
      max-width: 55px;
    }

    .cart-item.compact .product-info .title {
      font-size: 13px;
    }

    .cart-item.compact .btn-minus,
    .cart-item.compact .btn-plus {
      width: 28px;
      height: 28px;
      font-size: 16px;
    }

    .cart-item.compact .number-input {
      width: 40px;
      height: 24px;
      font-size: 14px;
    }

    .cart-item.compact .price {
      font-size: 14px !important;
    }

    .cart-item.compact .remove-icon {
      height: 24px;
    }
  }

  /* Mobile très petit (320px) */
  @media (max-width: 320px) {
    .section-header-breadcrumb .title-page {
      font-size: 20px;
      margin-top: 9px;
    }

    .cart-item .product-info .title {
      font-size: 12px;
    }
    .badge,
    .badge-blue {
      font-size: 1rem;
      display: none !important;
    }
    .step-cart .step-title {
      font-size: 9px !important;
      text-wrap-mode: nowrap;
    }
    .separator {
      display: block !important;
      width: 39px !important;
    }
    .btn-minus,
    .btn-plus {
      width: 25px;
      height: 25px;
      font-size: 14px;
    }

    .number-input {
      width: 35px;
      height: 25px;
      font-size: 12px;
    }

    .block-recap {
      padding: 12px;
    }

    .btn-check-order,
    .btn-clear-cart {
      font-size: 14px !important;
      padding: 6px 13px;
    }
  }

  .special-unity {
    display: block;
    width: fit-content;
    background-color: #ec621a;
    color: white;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: bold;
    margin-left: 0;
    margin-top: 5px;
  }
  .spinner-circle-small {
    display: inline-block;
    width: 17px;
    height: 17px;
    border: 2px solid #ccc;
    border-top-color: transparent;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  .spinner-circle-small-modal {
    display: inline-block;
    width: 13px;
    height: 13px;
    border: 2px solid #ccc;
    border-top-color: transparent;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  .spinner-circle-small.orange {
    border-color: #ec621a;
    border-top-color: transparent;
  }

  .spinner-circle-small.white {
    border-color: white;
    border-top-color: transparent;
  }

  /* delegue header */

  .delegate-header {
    padding: 15px 10%;
  }

  .delegate-info-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    padding: 15px 20px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 10px;
    backdrop-filter: blur(10px);
    border: 1px solid #aeb1ba;
  }

  .delegate-link {
    display: flex;
    align-items: center;
    gap: 8px;
    color: white;
    text-decoration: none;
    font-weight: 600;
    font-size: 14px;
    padding: 10px 15px;
    border-radius: 20px;
    transition: all 0.3s ease;
    background: #ec621a;
  }

  .delegate-link:hover {
    background: #bd4e15;
    transform: translateY(-2px);
  }

  .delegate-vet-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    text-align: center;
  }

  .vet-name {
    font-weight: bold;
    font-size: 16px;
  }

  .vet-code {
    font-size: 14px;
    opacity: 0.9;
    background: rgba(255, 255, 255, 0.1);
    padding: 4px 8px;
    border-radius: 4px;
  }

  .delegate-products-link {
    background: #ec621a;
  }

  .delegate-products-link:hover {
    background: #bd4e15;
  }

  /* Responsive Design */
  @media (max-width: 768px) {
    .delegate-info-box {
      flex-direction: column;
      gap: 15px;
      text-align: center;
    }

    .delegate-link {
      justify-content: center;
      width: 100%;
    }

    .delegate-vet-info {
      order: -1; /* Move vet info to top on mobile */
    }
  }

  @media (max-width: 480px) {
    .delegate-header {
      padding: 10px 0;
    }

    .delegate-info-box {
      padding: 12px 15px;
    }

    .delegate-link {
      font-size: 13px;
      padding: 8px 12px;
    }

    .vet-name {
      font-size: 14px;
    }

    .vet-code {
      font-size: 12px;
    }
    .badge,
    .badge-blue {
      font-size: 1rem;
      display: none !important;
    }
    .step-cart .step-title {
      font-size: 9px !important;
      text-wrap-mode: nowrap;
    }

    .separator {
      display: block !important;
      width: 39px !important;
    }
  }

  /* Promotion Styles */
  .promotions-container {
    margin-top: 8px;
  }

  .ug-promotion-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: linear-gradient(135deg, #ff6b35, #ec621a);
    color: white;
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    margin-right: 6px;
    margin-bottom: 4px;
  }

  .ug-promotion-badge i {
    font-size: 10px;
  }

  .promo-text {
    white-space: nowrap;
  }

  /* Optional: Add savings indicator in price block */
  .promotion-savings {
    font-size: 12px;
    color: #28a745;
    font-weight: 600;
    margin-top: 4px;
  }

  /* Update price display to show savings */
  .block-price {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .savings-badge {
    position: absolute;
    top: -8px;
    right: -8px;
    background: #28a745;
    color: white;
    border-radius: 8px;
    padding: 2px 6px;
    font-size: 10px;
    font-weight: bold;
  }

  .cart-item.promo-row .promo-quantity {
    font-weight: 700;
    color: #1e347d;
    font-size: 14px;
  }

  .cart-item.promo-row .quantity-controls.disabled {
    pointer-events: none;
    
  }

  .cart-item.promo-row .btn-minus.disabled,
  .cart-item.promo-row .btn-plus.disabled {
    background-color: rgba(236, 98, 26, 0.74);
    color: #fff;
    opacity: 0.7;
    cursor: not-allowed;
  }

  .cart-item.promo-row .number-input,
  .cart-item.promo-row .quantity-controls.disabled input {
    background: #f1f1f1;
    color: #9aa0a6;
    border-color: rgba(239, 139, 88, 0.25);
    cursor: not-allowed;
  }
  .summary-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.75rem;
    font-size: 0.95rem;
  }

  .clear-cart-link {
    color: #ec621a;
    font-size: 14px;
    text-decoration: underline;
    font-weight: 700;
    transition: color 0.2s;
  }

  .clear-cart-link:hover {
    color: #bd4e15;
    text-decoration: none;
  }

  .clear-cart-link.disabled {
    color: #ccc;
    pointer-events: none;
  }

  /* Modale */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    backdrop-filter: blur(3px);
  }

  .modal-content {
    background: white;
    border-radius: 12px;
    width: 90%;
    max-width: 500px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    overflow: hidden;
  }

  .modal-header {
    padding: 20px 20px 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
  }

  .modal-header h3 {
    margin: 0;
    font-size: 18px;
    color: #1e347d;
    font-weight: bold;
  }

  .modal-close {
    background: none;
    border: none;
    font-size: 24px;
    color: #999;
    cursor: pointer;
  }

  .modal-body {
    padding: 20px;
    text-align: center;
    color: #333;
  }

  .modal-body p {
    margin: 8px 0;
    font-size: 15px;
  }

  .modal-footer {
    padding: 15px 20px;
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    border-top: 1px solid #eee;
  }
  .btn-outline-secondary {
    border-radius: 50px;
    padding: 8px 16px;
    font-weight: bold;
  }
  .btn-danger {
    background-color: #dc3545 !important;
    color: white;
    border: none;
    border-radius: 50px;
    padding: 8px 16px;
    font-weight: bold;
  }
  .btn-danger:hover {
    border: 1px solid;
    color: #dc3545 !important;
    background-color: white !important;
    border-radius: 50px;
    padding: 8px 16px;
    font-weight: bold;
  }

  /* Preorder alert */
  .preorder-alert {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    background-color: #fff8e1;
    border: 1px solid #f9a825;
    border-left: 4px solid #f9a825;
    border-radius: 8px;
    padding: 14px 16px;
    color: #5a4200;
    font-size: 14px;
    line-height: 1.5;
  }

  .preorder-alert i {
    font-size: 20px;
    color: #f9a825;
    flex-shrink: 0;
    margin-top: 2px;
  }

  .preorder-alert strong {
    color: #3d2b00;
  }

  .preorder-badge {
    display: inline-block;
    background-color: #1e347d;
    color: #fff;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 600;
    margin-bottom: 4px;
    margin-top: 2px;
  }
</style>

